module.exports = __webpack_public_path__ + "img/button-POP-single.62c1d69d.svg";